export default __webpack_public_path__ + "static/media/logo.788d1e5b.PNG";